import React from 'react';
import styles from './FormFilter.module.scss';
import { Form } from 'antd';
import {
  GeneralCard,
  PeriodSelectionCard,
  SubjectStatusViewCard,
  DocumentParametersCard,
} from '../cards';
import RelatedPersonsCard from '../cards/RelatedPersonsCard/RelatedPersonsCard';
import AddressCard from '../cards/AddressCard/AddressCard';
import SavedFilter from '../SavedFilter/SavedFilter';

const FormContainer = () => {
  return (
    <div className={styles.root}>
      <SavedFilter />
      <Form>
        <div className={styles.contentForm}>
          <GeneralCard />
          <PeriodSelectionCard />
          <AddressCard />
          <SubjectStatusViewCard />
          <DocumentParametersCard />
          <RelatedPersonsCard />
        </div>
      </Form>
    </div>
  );
};

const FormFilter = Form.create({ name: 'filterForm' })(FormContainer);
export default FormFilter;
